import React from 'react';
import { Toaster } from 'react-hot-toast';

import MainContent from '../../components/mainContent/MainContent';
import { Outlet } from 'react-router-dom';
import { GenerarMinutaGrilla } from './components/GenerarMinutaGrilla';

export default function GenerarMinuta() {
  return (
    <>
      <MainContent
        titulo='Generar Minuta'
        component={<GenerarMinutaGrilla />}
        tableMaxWidth
      />
      <Outlet />
    </>
  );
}